import styled from 'styled-components';

export const PositionsWrapper = styled.div`
  margin-top: 33px;
  margin-bottom: 25px;

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;

    .ant-checkbox-wrapper {
      align-items: center;
      margin: 0 0 20px;
    }
  }

  .ant-legacy-form-item {
    margin-bottom: 20px;
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
